import axios from "@/request";

export default {
  /* 日志详情 */
  async info(params: any) {
    return axios.get("invest-log/info", { params });
  },
  /* 管理日志 */
  async list(params: any) {
    return axios.get("invest-log/list", { params });
  },
  /* 审核日志 */
  async audits(params: any) {
    return axios.get("invest-log/list-audit", { params });
  },
  /* 纠错日志 */
  async correct(params: any) {
    return axios.get("invest-log/list-correct", { params });
  },
}
